export const getElementHeight = (element: HTMLDivElement): number => {
    toggleElementVisibilityForHeightCalc(element);
    const height = element.offsetHeight;
    toggleElementVisibilityForHeightCalc(element);
    return height;
};

const toggleElementVisibilityForHeightCalc = (element: HTMLDivElement) => {
    if (element.style.visibility == 'visible') {
        element.style.height = '0';
        element.style.visibility = '';
    } else {
        element.style.height = 'auto';
        element.style.visibility = 'visible';
    }
};
